module.exports = __webpack_public_path__ + "static/media/map.0b4055c9.gif";